module.exports = __webpack_public_path__ + "img/looi.fd7a4465.png";